;(function () {
  angular.module('contrast.newuser').controller('newUserCtrl', newUserCtrl)

  function newUserCtrl(
    $scope,
    $q,
    $location,
    logger,
    ErrorService,
    UserService,
    ProfileService,
    ProfileFactory,
    OrganizationFactory,
    avatarFactory,
    UserFactory,
    ORG_ROLES,
    ROLES
  ) {
    'ngInject'

    var userUid = null
    var isFreemium = false
    var isCloudNativeOrganization = false

    function init() {
      if (!ProfileService.getNewUserOnboardingPreference()) {
        $location.path(UserService.buildUrl('/dashboard', true))
      } else if (
        $location.url().indexOf('profile') > -1 ||
        $location.url().indexOf('tour') > -1
      ) {
        $location.path(UserService.buildUrl('/newuser', true))
      }

      getRoles()
      getProfile()
      getOrganization()
    }

    angular.extend($scope, {
      name: '',
      rolesList: ORG_ROLES,
      rolesLookup: ROLES,
      role: ORG_ROLES.VIEW,
      organization: '',
      applications: 0,
      preferences: {
        accepted: false,
        avatar: undefined,
        avatarUrl: null,
        saving: false,
        finishing: false
      },
      isFreeTrial: false
    })

    angular.extend($scope, {
      savePreferences: savePreferences,
      goToAgentPage: goToAgentPage,
      goToApplicationPage: goToApplicationPage
    })

    function getProfile() {
      return ProfileFactory.getProfile().then(function (response) {
        $scope.name = response.data.user.first_name
        userUid = response.data.user.user_uid
        return getAvatar(userUid)
      }, ErrorService.processError)
    }

    function getRoles() {
      return OrganizationFactory.getApplicationRoles().then(function (
        response
      ) {
        $scope.applications = response.data.applications.length
        $scope.role = response.data.org_role
      },
      ErrorService.processError)
    }

    function getOrganization() {
      return OrganizationFactory.getOrganizationExpand(
        'freemium,free_trial'
      ).then(function (response) {
        $scope.organization = response.data.organization.name
        isFreemium = response.data.organization.freemium
        isCloudNativeOrganization =
          response.data.organization.cloudnative_enabled
        if (response.data.organization.free_trial) {
          $scope.isFreeTrial = true
          $location.path(UserService.buildUrl('/newuser/profile', true))
        }
      }, ErrorService.processError)
    }

    function saveProfile() {
      var promises = []

      if ($scope.preferences.avatar) {
        promises.push(saveAvatar())
      }

      return $q.all(promises)
    }

    function savePreferences() {
      $scope.preferences.saving = true
      saveProfile().then(
        function () {
          $scope.preferences.saving = false
          if (isFreemium) {
            // For new freemium users who are using serverless,
            // we want to skip the tour and direct to the serverless tab
            if (isCloudNativeOrganization) {
              _exitWizard('/serverless')
            } else {
              $location.path(UserService.buildUrl('/newuser/tour', true))
            }
          } else {
            _exitWizard('/applications')
          }
        },
        function () {
          $scope.preferences.saving = false
        }
      )
    }

    function getAvatar(username) {
      return avatarFactory.getAvatarUrl(username).then(function (urlInfo) {
        $scope.preferences.avatarUrl = urlInfo.url
        $scope.preferences.gravatar = urlInfo.gravatar
        if (urlInfo.avatar) {
          $scope.avatarUrl = urlInfo.avatar
        }
      })
    }

    function saveAvatar() {
      return avatarFactory
        .uploadUserAvatar($scope.preferences.avatar)
        .catch(function (response) {
          logger.logError('Unable to upload avatar')
          return $q.reject(response)
        })
    }

    function goToAgentPage() {
      _exitWizard('/wizard/download/JAVA')
    }

    function goToApplicationPage() {
      _exitWizard('/applications')
    }

    function _exitWizard(path) {
      $scope.preferences.finishing = true
      return UserFactory.updateNewUserOnboardingPreference()
        .then(function () {
          ProfileService.setNewUserOnboardingPreference(false)
          $location.path(UserService.buildUrl(path), true)
        }, ErrorService.processError)
        .finally(function () {
          $scope.preferences.finishing = false
        })
    }

    init()
  }
})()
